import { render } from "./ChoiceStep.vue?vue&type=template&id=165734f4"
import script from "./ChoiceStep.vue?vue&type=script&lang=js"
export * from "./ChoiceStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__